import { INavigationItem } from "@origin-digital/navigation-client-sdk";

export const isActiveNavSection = (href?: string): boolean => {
  const pathname = global?.window?.location?.pathname;

  if (!pathname || !href) {
    return false;
  }

  // Exact match or exact match with trailing slash
  if (pathname === href || pathname === `${href}/`) {
    return true;
  }

  // Support service-specific usage routes like /my/internet/usage, /my/service/lpg/usage, etc.
  // Also support child routes under /my/usage/ like /my/usage/electricity (one level only)
  // These should also activate the Usage tab
  if (href === "/my/usage") {
    const serviceTypeUsagePattern = /^\/my\/(?:[a-z0-9-]+\/)+usage$/;
    const usageChildRoutePattern = /^\/my\/usage\/[a-z0-9-]+$/;
    if (
      serviceTypeUsagePattern.test(pathname) ||
      usageChildRoutePattern.test(pathname)
    ) {
      return true;
    }
  }

  return false;
};

export const hasChildren = (navLinkConfig: INavigationItem): boolean =>
  !!navLinkConfig.children && navLinkConfig.children.length > 0;
